import React from 'react'
import { Route, Switch } from 'react-router-dom'
import AdministrativeInsertionContainer from './AdministrativeInsertion/AdministrativeInsertionContainer'
import PatientCreationContainer from './PatientCreation/PatientCreationContainer'

const Administrative = ({match}) => {
  const { url } = match
  return <Switch>
    <Route
      exact
      path={`${url}`}
      render={props => <AdministrativeInsertionContainer {...props} />}
    />
    <Route
      path={`${url}/new`}
      render={props => <PatientCreationContainer {...props} />} />
  </Switch>
}

export default Administrative
